// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__r1+ms","left":"Header_left__CF6SZ","right":"Header_right__lXdsR"};